<!--- Formulario frmManageShoppingLocationIndex ---->
<!---
Descripción del componente y comportamiento:
CASO DE USO:
* APP06_Gestionar Ubicación Compras
* https://grupohispatec.sharepoint.com/:w:/s/Produccin/EbRLToTQWz5CkDF3YejIaXIBtI7vfM83AEXhJfmMuCJsyg?e=PGajVl
---------------------------
- Formulario para Gestionar la ubicación de las compras.

Eventos escuchados por el formulario:
-----------------------

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <f7-page class="main-frmManageShoppingLocationDetails">
    <template #fixed>
      <TheNavbar
        :nav-title=" `${locationSelected.Codigo} - ${locationSelected.Nombre}`"
        :back-btn-enable="true"
        :back-callback="BackToMain"
        add-btn-enable
        :style="appTheme"
        @add-btn="EventAddNewArticle"
      />
    </template>
    <div class="padding-half header">
      <!-- Documento origen Albaran de compra -->
      <span
        v-if="!showPreload && locationList != null && locationList.TipoDocumentoOrigen === 1"
        class="header__texto margin-top-half limit-line"
      >
        Albarán Compra: {{ `${locationList.DocumentoOrigen.Serie}/${locationList.DocumentoOrigen.Numero} ${locationList.DocumentoOrigen.Proveedor?.NombreProveedor || ''}` }}
      </span>
      <!-- Sin documento de origen -->
      <span
        v-if="!showPreload && locationList != null && locationList.TipoDocumentoOrigen === 0"
        class="header__texto margin-top-half"
      >
        <span class="header__title">Lista de ubicaciones:</span>
        <span class="header__texto"> {{ `${locationList.Serie}/${locationList.Numero}` }} </span>
      </span>
    </div>
    <UCEmptyList
      v-if="(locationsArticlesSelected === null || locationsArticlesSelected.length === 0) && !showPreload"
      class="emptyList"
      title="Sin artículos en esta ubicación"
      subtitle="Pulse el botón para añadir un artículo"
      :icon="iconAdd"
      @click-icon="EventAddNewArticle"
    />
    <UCPreload :show="showPreload" />
    <div
      v-if="!showPreload && locationList != null && locationList.hasOwnProperty('Lineas') && locationList.Lineas != null && locationList.Lineas.length > 0"
    >
      <f7-list
        v-for="(item, i) in locationsArticlesSelected"
        :key="`article-${i}`"
        class="list-articles"
        media-list
      >
        <f7-list-item
          :class="{ 'item-selected': itemQuantitySelected != null && item.Articulo === itemQuantitySelected.Articulo }"
          link="#"
          :subtitle="`${item.Articulo != null ? item.Articulo.Codigo : ''}`"
          :text="!item.UbicadoEnUbicacionPorDefecto ? 'El artículo no está ubicado en la ubicación por defecto' : ''"
          @click="EventArticleQuantitySelected(item)"
        >
          <template #title>
            <div>
              <span class="titlea">
                {{ item.Articulo != null ? item.Articulo.Nombre : '' }}
              </span>
              <img
                v-if="!item.UbicadoEnUbicacionPorDefecto"
                class="padding-right-half"
                width="20"
                alt="gola"
                src="@/static/icons/ic_warning.svg"
              >
              <div class="btn-add-info-output-worker">
                <img
                  class="content-list-queue-item__icon"
                  width="20"
                  alt="iconInfo"
                  src="@/static/img/ic_gallery.svg"
                  @click="OpenImagenesEntidad(item)"
                >
              </div>
            </div>
          </template>

          <template #after>
            <div :class="item.CantidadPosicionada >= item.CantidadPosicionar ? 'item-after-complete' : 'item-after-incomplete'">
              {{
                item.hasOwnProperty('CantidadPosicionada')
                  ? item.CantidadPosicionada
                  : 0
              }}
              de
              {{
                item.hasOwnProperty('CantidadPosicionar')
                  ? item.CantidadPosicionar
                  : 0
              }}
            </div>
          </template>
        </f7-list-item>
      </f7-list>
    </div>
    <div class="content-button">
      <f7-button
        class="btn-confirmar"
        fill
        @click="ScanItem()"
      >
        Escanear artículo
      </f7-button>
    </div>

    <UCCodeScanner
      ref="UCCodeScanner"
      :fab-button-show="false"
      :allow-manual-code-entry="true"
      :autofocus-on-input="true"
      @code-reading="CodeScannerReaded"
      @codigo-barras="CodeScannerReaded"
    />

    <!-- ACTION DEL FORMULARIO -->
    <!-- Action selección de cantidades posicionar. -->
    <f7-actions
      v-if="itemQuantitySelected != null"
      class="frmManageShoppingLocationDetails-actions"
      :grid="true"
      :opened="actionQuantitySelectionPositioningOpened"
      @actions:closed="EventActionQuantitySelectionPositioningClosed()"
    >
      <f7-actions-group>
        <!-- Without PeticionNumeroSerie -->
        <template v-if="!itemQuantitySelected.Articulo.PeticionNumeroSerie">
          <f7-actions-label class="content-action__label margin-top">
            Ha seleccionado el artículo "{{ `${itemQuantitySelected.Articulo.Codigo} - ${itemQuantitySelected.Articulo.Nombre}` }}"
            ¿Qué cantidad desea ubicar?
          </f7-actions-label>
          <div class="content-stepper text-align-center">
            <br>
            <div
              class="stepper stepper-fill stepper-init"
            >
              <f7-stepper
                fill
                :value="CalculateStepperValue(itemQuantitySelected)"
                :max="CalculateStepperValue(itemQuantitySelected)"
                :manual-input-mode="true"
                :decimal-point="itemQuantitySelected.Articulo.PrecisionCantidades"
                @input="quantityPositionSelectedArticle = $event.target.value"
              />
            </div>
          </div>
        </template>

        <!-- With PeticionNumeroSerie -->
        <template v-else>
          <f7-actions-label class="content-action__label margin-top">
            Ha seleccionado el artículo "{{ `${itemQuantitySelected.Articulo.Codigo} - ${itemQuantitySelected.Articulo.Nombre}` }}"
            ¿Qué número de serie desea ubicar?
          </f7-actions-label>

          <div class="content-action__serial-number display-flex justify-content-center">
            <UCSearchEntityERP
              :placeholder="$t('searchEntity.serialNumber.placeholder.serialNumber')"
              :search-text="$t('searchEntity.serialNumber.searchText')"
              :search-cancellation-text="$t('searchEntity.serialNumber.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.serialNumber.searchNotFoundText')"
              :default-etities-list="itemQuantitySelected.AcumuladoExistencias"
              :property-entity-shown-input="['NumeroSerie']"
              :property-entity-shown-list-title="['NumeroSerie']"
              :emit-evet-change-default-value="true"
              @open-popup-search-entities="actionQuantitySelectionPositioningTempClose = true; actionQuantitySelectionPositioningOpened = false"
              @close-popup-search-entities="actionQuantitySelectionPositioningTempClose = false; actionQuantitySelectionPositioningOpened = true"
              @selection="EventSelectedSerialNumber"
            />
          </div>
        </template>

        <div class="action-buttons display-flex justify-content-space-between margin">
          <f7-button
            color="gray"
            @click="actionQuantitySelectionPositioningOpened = false;"
          >
            {{ $t('common.cancel') }}
          </f7-button>
          <f7-button
            color="green"
            :class="{ 'disabled-element': quantityPositionSelectedArticle <= 0.0 }"
            @click="Confirm"
          >
            {{ $t('common.confirm') }}
          </f7-button>
        </div>
      </f7-actions-group>
    </f7-actions>

    <!-- POPUP DEL FORMULARIO -->
    <f7-popup
      class="frmManageShoppingLocationDetails-popup-barcode"
      :opened="popupAddNewArticleOpened"
      @popup:closed="EventClosePopupAddNewArticle"
    >
      <f7-page>
        <template #fixed>
          <TheNavbar
            :nav-title="`Añadir artículo en ubicación ${locationSelected.Nombre}`"
            :popup-close-btn-enable="true"
            :style="appTheme"
          />
        </template>
        <f7-block>
          <span>¿Qué artículo desea añadir?</span>

          <UCSearchEntityERP
            :placeholder="$t('common.articles')"
            :search-text="$t('searchEntity.article.searchText')"
            :search-cancellation-text="$t('searchEntity.article.searchCancellationText')"
            :search-not-found-text="$t('searchEntity.article.searchNotFoundText')"
            :default-etities-list="itemProductForNew"
            :property-entity-shown-input="['Codigo', 'Nombre']"
            :property-entity-shown-list-title="['Codigo']"
            :property-entity-shown-list-subtitle="['Nombre']"
            :autofocus-on-deselection="true"
            :auto-focus-on-empty-search-result="true"
            @selection="itemForNew = $event"
          />
          <br>
          <div v-if="itemForNew != null">
            <!-- Without PeticionNumeroSerie -->
            <template v-if="!itemForNew.PeticionNumeroSerie">
              <span>Cantidad Posicionar:</span>
              <div class="content-stepper text-align-center">
                <br>
                <div class="stepper stepper-fill stepper-init">
                  <f7-stepper
                    fill
                    :value="Number(itemForNewMaxQuantity)"
                    :max="Number(itemForNewMaxQuantity)"
                    @input="quantityPositionSelectedArticle = Number($event.target.value)"
                  />
                </div>
              </div>
            </template>

            <!-- With PeticionNumeroSerie -->
            <template v-else>
              <span>¿Qué número de serie desea añadir?</span>

              <UCSearchEntityERP
                :placeholder="$t('searchEntity.serialNumber.placeholder.serialNumber')"
                :search-text="$t('searchEntity.serialNumber.searchText')"
                :search-cancellation-text="$t('searchEntity.serialNumber.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.serialNumber.searchNotFoundText')"
                :default-etities-list="articleSerialNumbers"
                :property-entity-shown-input="['NumeroSerie']"
                :property-entity-shown-list-title="['NumeroSerie']"
                :emit-evet-change-default-value="true"
                @selection="EventSelectedSerialNumber"
              />
            </template>
          </div>

          <div class="action-buttons display-flex justify-content-space-between">
            <f7-button
              color="gray"
              @click="popupAddNewArticleOpened = false"
            >
              {{ $t('common.cancel') }}
            </f7-button>
            <f7-button
              :class="{ 'disabled-element': quantityPositionSelectedArticle < 1 || itemForNew === null }"
              color="green"
              @click="EventConfirmAddNewArticle"
            >
              {{ $t('common.confirm') }}
            </f7-button>
          </div>
        </f7-block>
      </f7-page>
    </f7-popup>
    <f7-popup
      class="frmManageShoppingLocationDetails-popup-images"
      :opened="popupImagenes"
      @popup:closed="popupImagenes = false"
    >
      <f7-navbar
        :title="$t('common.files')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupImagenes = false">
            <img
              :src="icClose"
              style="padding-right: 10px;"
            >
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <PCImagenesEntidad
        v-if="idEntidad != null"
        :is-active="popupImagenes"
        :entity-id="idEntidad"
        entity-type="Articulo"
        @open-pdf="popupImagenes = false"
      />
    </f7-popup>
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useInformationBar } from '@/composables/useInformationBar';
import { useCommercialisationStore } from '@/js/stores/commercialisation';
import { useParamRef } from '@erpagroapp/params';

import icAdd from '@/static/icons/ic_add_new.svg';
import TheNavbar from '@/components/TheNavbar.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import APIErp, { callExecuteSPERP } from '@/js/services/APIErp';
import ConexionTA from '@/js/services/traceability/APITraceability';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import UCEmptyList from '@/components/common/UCEmptyList.vue';
import PCImagenesEntidad from '@/components/production/traceability/PCImagenesEntidad.vue';
import icClose from '@/static/icons/ic_close.svg';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';

export default {
  name: 'FrmManageShoppingLocationDetails',
  components: {
    TheNavbar,
    UCPreload,
    UCSearchEntityERP,
    UCCodeScanner,
    UCEmptyList,
    PCImagenesEntidad,

  },
  /*
  props: {
    purchaseOrder: { type: Object, required: true, default: null },
    locationArticles: { type: Object, required: true, default: null },
  },
  */

  setup() {
    const { shouldShowInformationBar } = useInformationBar();
    return {
      shouldShowInformationBar,
    };
  },

  data() {
    return {
      showPreload: false, // Mostrar preload
      itemQuantitySelected: null, // Artículo con cantidad seleccionado
      itemForNew: null, // Artículo seleccionado para añadir de entre los artículos del albaran de compra.
      itemForNewMaxQuantity: 0, // Cantidad máxima del articulo seleccionado para añadir en la ubicación.
      actionQuantitySelectionPositioningOpened: false, // actión que permite establecer la cantidad a posicionar
      actionQuantitySelectionPositioningTempClose: false, // Indica si el action fue cerrado de forma temporal para no restablecer los valores
      popupAddNewArticleOpened: false, // actión que permite añadir un nuevo artículo
      quantityPositionSelectedArticle: 0, // Cantidad a posicionar del artículo seleccionado
      selectedExistence: null, // AcumuladoExistencias seleccionado cuando se trata de PeticionNumeroSerie
      popupImagenes: false,
      idEntidad: null, // id de la entidad a pasar a PCImagenes entidad
      optionsSelected: false, // Para solo mostrar el Popup o las imagenes
      icClose,
      disallowLocationAdvancement: useParamRef('NoPermitirAvanzarEnGestionUbicacionesAPP'),
    };
  },
  computed: {
    ...mapState(useCommercialisationStore, [
      'locationList', // Albaran de compra seleccionado
      'locationSelected', // Ubicación seleccionada
      'locationsArticlesSelected', // Artículos de la ubicación seleccionada
    ]),
    ...mapWritableState(useCommercialisationStore, ['ResetFrmLocation']),

    // Lista de artículos del locacation list que NO estan ya en la ubicación seleccionada
    itemProductForNew() {
      if (this.locationsArticlesSelected === null || this.locationList === null) {
        return [];
      }
      return this.locationList.Lineas.map(
        (obj) => obj.Articulo,
      ).filter((obj2) => !this.locationsArticlesSelected.some((filtro) => filtro.Articulo.Id === obj2.Id));
    },

    articleSerialNumbers() {
      if (this.itemForNew === null) {
        return [];
      }

      return this.locationList.Lineas
        .flatMap((l) => l.AcumuladoExistencias)
        .filter((ae) => ae.Articulo.Id === this.itemForNew.Id);
    },

    iconAdd() {
      return icAdd;
    },
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },

    /**
     * Returns the maximum height for the accordion.
     * @returns {string} The maximum height for the accordion, in percents.
     */
    maxAccordionHeight() {
      return this.shouldShowInformationBar ? '80%' : '88%';
    },
  },
  watch: {
    // whenever question changes, this function will run
    itemForNew(newItem) {
      if (newItem != null) {
        const elemento = this.locationList.Lineas.filter((e) => e.Articulo.Id === newItem.Id);
        this.itemForNewMaxQuantity = Number(elemento[0].CantidadPosicionar) - Number(elemento[0].CantidadPosicionada);
        this.quantityPositionSelectedArticle = this.itemForNewMaxQuantity; // Se inicializa con la máxima cantidad
      } else {
        this.itemForNewMaxQuantity = 0;
      }
    },
  },

  methods: {
    BackToMain() {
      f7.views.main.router.back();
    },

    async Confirm() {
      Log(this, this.Confirm.name);

      const serialNumberRequest = this.itemQuantitySelected.Articulo.PeticionNumeroSerie === true;
      let serialNumber = null;

      if (serialNumberRequest) {
        this.quantityPositionSelectedArticle = 1;
        serialNumber = this.selectedExistence.NumeroSerie;
      }

      this.actionQuantitySelectionPositioningOpened = false;

      HiDialog.Preloader(true, 'Actualizando cantidades ubicadas', false);

      try {
        await this.Conections_UpdateQuantityLocatedArticle(
          this.itemQuantitySelected.Id,
          this.itemQuantitySelected.Ubicacion.Id,
          this.itemQuantitySelected.Ubicacion.Id,
          this.quantityPositionSelectedArticle,
          serialNumber,
        );

        this.ResetFrmLocation = true;
      } catch (error) {
        LogError(this, this.Confirm.name, error);
        HiNotification.Toast('No se ha podido actualizar cantidades ubicadas');
      } finally {
        HiDialog.Preloader(false);
      }
    },

    EventOpenReadBarCode() {
      Log(this, this.EventOpenReadBarCode.name);
    },
    EventArticleQuantitySelected(e, ignoreDisallowParam = false) {
      Log(this, this.EventArticleQuantitySelected.name);

      if (!ignoreDisallowParam && this.disallowLocationAdvancement) {
        return;
      }

      if (!this.optionsSelected) {
        this.itemQuantitySelected = e;
        this.quantityPositionSelectedArticle = this.itemQuantitySelected.CantidadPosicionar - this.itemQuantitySelected.CantidadPosicionada;

        if (this.itemQuantitySelected.CantidadPosicionar - this.itemQuantitySelected.CantidadPosicionada <= 0) {
          HiNotification.Toast('Se ha alcanzado el número máximo de artículos');
          return;
        }

        this.actionQuantitySelectionPositioningOpened = true;
      }

      this.optionsSelected = false;
    },
    EventLocationSelected(e) {
      Log(this, this.EventLocationSelected.name);
      if (e !== null) {
        this.$refs.UCCodeScanner.ClosePopup();
      }
      // this.NavigateToLocationDetails(e);
    },

    async EventArticleSelectionForSearch(objArticle) {
      Log(this, this.EventArticleSelectionForSearch.name);

      if (!objArticle) {
        return;
      }

      // El popup de busqueda de ubicaciones tarda en cerrarse, por lo que se espera un poco para que no se cierre antes de que se cierre el popup de lectura de codigo.
      await sleep(200);
      this.$refs.UCCodeScanner.ClosePopup();

      // Buscar si el artículo esta en la lista de locationsArticlesSelected
      const foundItems = this.locationsArticlesSelected.filter((e) => e.Articulo.Id === objArticle.Id);

      if (foundItems.length === 0) {
        const itemFoundAlternative = this.itemProductForNew.find((e) => e.Id === objArticle.Id);

        if (itemFoundAlternative !== undefined) {
          HiNotification.Alert('El artículo no se encuentra predefinido para ser ubicado en esta ubicación pero puedes añadirlo como un nuevo artículo en la ubicación seleccionada', 'No es posible añadir el artículo.');
          return;
        }

        HiNotification.Alert(`No es posible añadir el artículo. El artículo no se encuentra en la lista de ubicaciones  ${this.locationList.Serie}/${this.locationList.Numero}`, 'No es posible añadir el artículo.');
        return;
      }

      const foundItem = foundItems.find((e) => e.CantidadPosicionada < e.CantidadPosicionar);

      if (!foundItem) {
        HiNotification.Alert('Se ha ubicado toda la cantidad del artículo', 'No es posible añadir el artículo.');
        return;
      }

      this.EventArticleQuantitySelected(foundItem, true);
    },

    CodeScannerReaded(barCode) {
      Log(this, this.CodeScannerReaded.name);

      const itemFound = this.locationList.Lineas.find((e) => e.Articulo.CodigosBarras.some((e2) => e2.Codigo === barCode));

      if (itemFound) {
        this.EventArticleSelectionForSearch(itemFound.Articulo);
      } else {
        HiNotification.Alert(`No se ha encontrado ningún artículo con el código de barras leído en la lista de ubicaciones  ${this.locationList.Serie}/${this.locationList.Numero}`, 'No es posible añadir el artículo.');
      }
    },
    EventAddNewArticle() {
      Log(this, this.EventAddNewArticle.name);
      this.popupAddNewArticleOpened = true;
    },

    async EventConfirmAddNewArticle() {
      Log(this, this.EventConfirmAddNewArticle.name);

      const serialNumberRequest = this.itemForNew.PeticionNumeroSerie === true;
      let serialNumber = null;

      if (serialNumberRequest) {
        this.quantityPositionSelectedArticle = 1;
        serialNumber = this.selectedExistence.NumeroSerie;
      }

      try {
        HiDialog.Preloader(true, 'Actualizando cantidades ubicadas', false);

        const elemento = this.locationList.Lineas.filter((e) => e.Articulo.Id === this.itemForNew.Id);
        if (elemento[0].CantidadPosicionada + this.quantityPositionSelectedArticle > elemento[0].CantidadPosicionar) {
          HiDialog.Preloader(false);
          // this.popupAddNewArticleOpened = false;
          HiNotification.Toast(`El máximo número de elementos pendientes de posicionar para este articulo son ${Number(elemento[0].CantidadPosicionar) - Number(elemento[0].CantidadPosicionada)}`);
          return;
        }

        await this.Conections_UpdateQuantityLocatedArticle(
          elemento[0].Id,
          this.locationSelected.Id,
          elemento[0].Ubicacion.Id,
          this.quantityPositionSelectedArticle,
          serialNumber,
        );

        // Al hacer el cambio de mercancía, si el almacén origen no es movil y la ubicación destino sobre la que se mueve la mercancía no es la ubicación por defecto del artículo
        // se imprimirá el impreso de negocio 0897
        if ((elemento[0].Ubicacion.Almacen && !elemento[0].Ubicacion.Almacen.AlmacenMovil) && elemento[0].Ubicacion.Id !== this.locationSelected.Id) {
          HiNotification.Toast('Se imprimirá el documento de sobrestock');
        }

        this.ResetFrmLocation = true;
        this.popupAddNewArticleOpened = false;
      } catch (error) {
        LogError(this, this.EventConfirmAddNewArticle.name, error);
      } finally {
        HiDialog.Preloader(false);
      }
    },

    /**
     * Calculate and return the stepper value based on the provided item.
     * @param {object} item - The item for which to calculate the stepper value.
     * @returns {number} - The calculated stepper value.
     */
    CalculateStepperValue(item) {
      const calculatedValue = Number((item.CantidadPosicionar - item.CantidadPosicionada).toFixed(item.Articulo.PrecisionCantidades));
      return calculatedValue < 0 ? 0 : calculatedValue;
    },

    EventActionQuantitySelectionPositioningClosed() {
      Log(this, this.EventActionQuantitySelectionPositioningClosed.name);

      if (this.actionQuantitySelectionPositioningTempClose) {
        return;
      }

      this.itemQuantitySelected = null;
      this.quantityPositionSelectedArticle = 0;
      this.actionQuantitySelectionPositioningOpened = false;
    },

    EventSelectedSerialNumber(e) {
      Log(this, this.EventSelectedSerialNumber.name);
      this.selectedExistence = e;
    },

    EventClosePopupAddNewArticle() {
      Log(this, this.EventClosePopupAddNewArticle.name);
      this.popupAddNewArticleOpened = false;
      this.itemForNew = null;
    },
    ScanItem() {
      Log(this, this.ScanItem.name);
      this.$refs.UCCodeScanner.Open();
    },
    OpenImagenesEntidad(item) {
      this.optionsSelected = true;
      this.idEntidad = item.Articulo.Id;
      this.popupImagenes = true;
    },

    async Conections_GetPurchaseOrder(codeSearch) {
      Log(this, this.Conections_GetPurchaseOrder.name);
      try {
        const result = await callExecuteSPERP('APPERPAGRO_LocationListXAlbaranCompra', [{ NombreParametro: 'codigo', Valor: codeSearch }]);
        if ((result.statusText === 'OK' || result.status === 200) && result.data.length > 0) {
          return result.data[0];
        }
      } catch (error) {
        LogError(this, this.Conections_GetPurchaseOrder.name, error);
      }
      return null;
    },

    async Conections_UpdateQuantityLocatedArticle(idMerchandiseListOfLocations, idLocationOfDestination, idDefaultLocation, quantity, serialNumber = null) {
      Log(this, this.Conections_UpdateQuantityLocatedArticle.name);

      try {
        const result = await APIErp.callUpdateQuantityLocationList(
          idMerchandiseListOfLocations,
          idLocationOfDestination,
          idDefaultLocation,
          quantity,
          serialNumber,
        );

        if (result.statusText === 'OK' || result.status === 200) {
          if (result.data.Mensaje !== null) {
            HiNotification.Toast('Se imprimirá el documento de sobrestock');
          }
          return result.data;
        }
      } catch (error) {
        LogError(this, this.Conections_UpdateQuantityLocatedArticle.name, error);
      }
      return null;
    },

    GetLocations() {
      Log(this, this.GetLocations.name);
      return ConexionTA.callObtenerUbicaciones();
    },
    GetLocationByFilter(filter) {
      Log(this, this.GetLocationByFilter.name);
      return ConexionTA.callObtenerUbicacionPorCodigo(filter);
    },
  },
};
</script>

<style lang="scss">
.main-frmManageShoppingLocationDetails {
  .page-content {
    // It is necessary because there is a fixed button in the footer
    max-height: v-bind(maxAccordionHeight);

    // This is for correct visualization of the acordion list because there is a fixed header
    padding-top: calc(var(--f7-page-navbar-offset) + 39px);
  }

  .limit-line {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }

  .item-after-complete {
    background-color: var(--his-greensoft);
    color: var(--his-greendark);
    padding: 4px 8px;
    border-radius: 3px;
  }

  .item-after-incomplete {
    background-color: var(--his-mandarina-tint);
    padding: 4px 8px;
    border-radius: 3px;
  }

  .disabled {
    opacity: 0.6;
    pointer-events: none;
  }

  .header {
    position: fixed;
    top: var(--f7-navbar-height);
    z-index: 10;
    width: 100%;
    background: var(--his-oliva);

    span {
      color: #fff;
    }

    &__title {
      margin-left: 8px;
      font-size: 12px;
      opacity: 0.8;
    }

    &__texto {
      font-size: 14px;
    }
  }

  .list-articles {
    --f7-list-item-title-text-color: var(--his-dark-blue);
    --f7-list-item-title-font-size: 16px;
    --f7-list-media-item-title-font-weight: 600;
    --f7-list-item-after-font-size: 11px;
    --f7-list-item-after-text-color: #ba5333;
    --f7-list-item-after-font-weight: 500;
    --f7-list-item-subtitle-font-size: 11px;
    --f7-list-item-subtitle-line-height: 1.8;
    --f7-list-item-subtitle-text-color: var(--his-oliva);
    --f7-list-item-text-font-size: 11px;
    --f7-list-item-text-text-color: var(--his-tomate-dark);
    --f7-list-item-text-line-height: 1;

    .item-title-row {
      align-items: center;
    }

    .item-subtitle {
      display: flex;
      justify-content: space-between;

      .btn-add-info-output-worker {
        margin-top: 5px;
        padding-right: 45px;
      }
    }

    .item-selected {
      background-color: #d8d8d8;
    }

    .item-title {
      div {
        display: flex;
        justify-content: flex-end;
        flex-direction: row-reverse;

        .titlea {
          -webkit-box-orient: vertical;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          margin-top: 2px;
        }

        .btn-add-info-output-worker {
          margin-right: 10px;
        }
      }
    }
  }

  .content-button {
    position: fixed;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    bottom: 0;
    margin-bottom: calc(25px + var(--information-bar-height));

    .button {
      width: 90%;
      --f7-button-pressed-bg-color: var(--his-slate-blue);
      --f7-button-bg-color: var(--his-green);
    }
  }
}

.frmManageShoppingLocationDetails-popup-barcode {
  position: absolute;

  @media only screen and (min-width: 701px) {
    top: 55%;

    .action-buttons {
      width: 100%;
      margin-top: 35vh;
    }
  }

  @media only screen and (max-width: 700px) {
    top: 55%;

    .action-buttons {
      width: 100%;
      margin-top: 2vh;
    }
  }
}

.frmManageShoppingLocationDetails-actions {
  .content-action {
    &__label {
      display: block;
      text-align: center;
      color: var(--his-oliva);
    }

    &__serial-number {
      width: 100%;
    }
  }
}

.frmManageShoppingLocationDetails-popup-images {
  overflow-y: scroll;
}

.frmManageShoppingLocationDetails-popup-barcode,
.frmManageShoppingLocationDetails-actions {
  .action-buttons {
    width: 100%;
  }

  .content-stepper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
}

.main-frmManageShoppingLocationDetails,
.frmManageShoppingLocationDetails-popup-barcode {
  .navbar {
    .navbar-inner {
      // Fix buttons being hidden when title in the Navbar is too long
      // However, it should be fixed in the Navbar component instead
      .left {
        overflow: hidden;
        text-overflow: ellipsis;
        width: calc(100% - 56px);
      }
    }
  }
}
</style>
